module.exports = __webpack_public_path__ + "img/aws-ml-cert.ce660c7a.png";